/* eslint-disable @typescript-eslint/no-explicit-any */
import { api_service } from '../api/api-service';
import { api_urls } from '../api/api-urls';

export interface AssetApiResponse {
    Id: string;
    AspireOId: string;
    ContractId: number;
    AssetName: string;
    AssetDesc: string;
    SerialNumber: string;
    Make: string;
    Model: string;
    Year: number;
    Address: string;
    City: string;
    State: string;
    Country: string;
    PostalCode: string;
    CreatedTime: string;
    UpdatedTime: string;
}

export interface AssetsResponse {
    statusCode: number;
    data: AssetApiResponse[];
    message?: string;
}

/**
 * Get assets for a contract
 * @param contractId - Contract ID
 * @param showLoader - Whether to show loading indicator (default: true)
 * @returns Promise with assets response
 */
export const getContractAssets = async (
    contractId: string | number,
    showLoader: boolean = true,
): Promise<AssetsResponse> => {
    try {
        const response: any = await api_service.get({
            endPoint: `${api_urls.GetAssets}/${contractId}`,
            showLoader,
        });
        const responseData = response?.data || response;

        if (responseData.statusCode && Array.isArray(responseData.data)) {
            return {
                statusCode: responseData.statusCode,
                data: responseData.data,
                message: responseData.message,
            };
        }

        return {
            statusCode: responseData.statusCode || 200,
            data: Array.isArray(responseData.data) ? responseData.data : responseData.data ? [responseData.data] : [],
            message: responseData.message,
        };
    } catch (error: any) {
        console.error('Error fetching contract assets:', error);
        throw error;
    }
};
